import React from 'react';
import "./container.css";

const Footer = () => {
    return (
        <footer className='footer'>
            <div className="footer-content">
                <span className="footer-logo-text">✕○</span>
                <span className="footer-text">TicTacToe Arena</span>
            </div>
        </footer>
    )
}

export default Footer;
